import request from '@/router/axios';

export const getList = (current, size, params, search) => {
    return request({
        url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/page',
        method: 'get',
        params: {
            ...params,
            ...search,
            current,
            size
        }
    })
}

export const remove = (id) => {
    return request({
        url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/remove',
        method: 'post',
        data: {
            id,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/submit',
        method: 'post',
        data: row
    })
}

export const updateBond = (row) => {
    return request({
        url: '/api/blade-loanSecurityDept/loanSecurityDept/updateSecurity',
        method: 'post',
        data: row
    })
}


export const exportData = (data) => {
    return request({
        url: `/api/blade-loanSecurityDept/loanSecurityDept/export-loanSecurityDept`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}

export const getRecordList = (current, size, search) => {
  return request({
      url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/storage/record',
      method: 'post',
      data: {
          ...search,
          current,
          size
      }
  })
}

export const takeInventory = (current, size, search) => {
  return request({
      url: '/api/blade-borrowkeycerfiticate/borrowkeycerfiticate/takeInventory',
      method: 'post',
      data: {
          ...search,
          current,
          size
      }
  })
}
